module.exports = __webpack_public_path__ + "img/upload_files.abdf978a.png";